module.exports = __webpack_public_path__ + "static/media/2.096b1712.mp3";